import { inject, Service } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../services/authentication/auth.service';
import { RuntimeConfigService } from '../services/config/runtime-config.service';
import { environment } from '../../environments/environment';

@Service()
export class AuthGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly config = inject(RuntimeConfigService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map((isAuth: boolean) => {
        if (!isAuth) {
          const ship = environment.ship;
          const authMode = this.config.get('authenticationMode');
          if (ship && authMode === 'identity') {
            this.router.navigate(['/auth/ship-login']);
          } else {
            this.authService.rememberReturnUrl(state.url);
            this.router.navigate(['/auth/login']);
          }
        }
        return isAuth;
      })
    );
  }
}
